"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UncenteredTrapeze = void 0;
var figureBase_1 = require("../../../core/base/figureBase");
var line3_1 = require("../../../core/base/line3");
var three_1 = require("three");
var UncenteredTrapeze = /** @class */ (function (_super) {
    __extends(UncenteredTrapeze, _super);
    function UncenteredTrapeze() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UncenteredTrapeze.prototype.calculateConnectionIndexes = function () {
        return [0, 1, 2, 3];
    };
    UncenteredTrapeze.prototype.calculateHoleLines = function () {
        return [];
    };
    UncenteredTrapeze.prototype.calculateLines = function () {
        var coords = this.config.options;
        var aPoint = new three_1.Vector3(coords.widthBottom / 2, 0);
        var bPoint = new three_1.Vector3(-coords.widthBottom / 2, 0);
        var cPoint = new three_1.Vector3(-coords.widthBottom / 2 + coords.wLeft, coords.height);
        var dPoint = new three_1.Vector3(coords.widthBottom / 2 - coords.wRight, coords.height);
        return [
            new line3_1.Line3(line3_1.LineType.Straight, [aPoint, bPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [bPoint, cPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [cPoint, dPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [dPoint, aPoint]),
        ];
    };
    UncenteredTrapeze.prototype.getConfigProperties = function () {
        return {
            widthBottom: 1,
            height: 0.6,
            wLeft: 0.1,
            wRight: 0.2,
        };
    };
    return UncenteredTrapeze;
}(figureBase_1.FigureBase));
exports.UncenteredTrapeze = UncenteredTrapeze;
